// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3SmWY","signatureButtonsRight":"ModalSign_signatureButtonsRight__Dc93l"};